(function(){
	'use strict';

	angular
		.module('theFoodApp')
		.constant('NOTIFICATION_TIME', 2000)
		.constant('DOUBLE_CLICK_TIME', 250);
})();
